// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-lane-config-form-baseLaneConfigForm-51dd2 .base-lane-config-form-labelSelector-5e425{background:var(--GRAY_10);border-radius:6px;display:flex;padding:16px 16px 0;width:484px}.base-lane-config-form-baseLaneConfigForm-51dd2 .base-lane-config-form-labelSelector-5e425 .base-lane-config-form-labelSelectorValue-e95f3{margin-left:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"baseLaneConfigForm": "base-lane-config-form-baseLaneConfigForm-51dd2",
	"labelSelector": "base-lane-config-form-labelSelector-5e425",
	"labelSelectorValue": "base-lane-config-form-labelSelectorValue-e95f3"
};
export default ___CSS_LOADER_EXPORT___;
